module.exports = __webpack_public_path__ + "media/application/images/svgs/flag-4cf1abcf3be9b602c0c6ea51ea3e6bac.svg";